import {observer} from 'mobx-react';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {OpenEndedQuestionStore} from './OpenEndedQuestionStore';

interface Props {
  x9: X9Content | X9ContentSnapshot
  store: X9ContentStateStore
}

@observer
export class TeacherOpenEndedQuestion extends React.Component<Props> {
  readonly store: OpenEndedQuestionStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new OpenEndedQuestionStore(props.x9.Id, props.store);
  }

  onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.store.updateAnswer(event.target.value);
  };

  render() {
    const store = this.store;

    return (
      <div className="row">
        <div className="col">
          <div className="open-ended-question-container">
            <TextareaAutosize className="open-ended-question-text-box w-100"
                              value={store.state.answer}
                              onChange={this.onChangeHandler}/>
          </div>
        </div>
      </div>);
  }

  componentWillUnmount() {
    this.store.updateAnswer('');
  }
}
